export default class FileFormResponse {
	constructor(formResponse) {
		this.id = formResponse.id;
		this.file = formResponse.file;
		this.fileMetadata = formResponse.file_metadata;
	}
}
